// extracted by mini-css-extract-plugin
export default {"container":"Services_container__MN1KT","top":"Services_top__okao-","servicesp":"Services_servicesp__msNtV","servicesh1":"Services_servicesh1__9RY8A"};